import axios from "axios";

const BASE_URL = process.env.REACT_APP_APIURL;
const BASE_FPAUPLOADURL = process.env.REACT_APP_FPAUPLOADAPIURL;

const BASE_URL_LIVE = process.env.REACT_APP_APIURL_LIVE;
const BASE_FPAUPLOADURL_LIVE = process.env.REACT_APP_FPAUPLOADAPIURL_LIVE;

const MAIN_URL =
  process.env.REACT_APP_DEV_ENV == "PRODUCTION" ? BASE_URL_LIVE : BASE_URL;
const MAIN_URL_FPA =
  process.env.REACT_APP_DEV_ENV == "PRODUCTION"
    ? BASE_FPAUPLOADURL_LIVE
    : BASE_FPAUPLOADURL;

let user = "";
let token = "";

export const getAxiosInstance = async (FPAUPLOAD = false) => {
  let lang =
    localStorage.getItem("lang") == undefined
      ? "en"
      : localStorage.getItem("lang");
  try {
    token = window.localStorage.getItem("USER_ACCESS_TOKEN");
  } catch (e) {
  } finally {
    let obj = {
      baseURL: FPAUPLOAD === false ? MAIN_URL : MAIN_URL_FPA,
      params: { lang },
      headers: {
        Accept: "application/json",
      },
    };

    if (FPAUPLOAD === false) {
      obj.headers.Authorization = `Bearer ${token}`;
    }

    const instance = axios.create(obj);
    instance.interceptors.request.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    return instance;
  }
};
